import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './PowertrainBasicInfo.scss';

/**
 * PowertrainBasicInfo - Reusable component for displaying powertrain basic information
 * Used in PowertrainWizard PreviewStep and PowertrainDetails components
 */
const PowertrainBasicInfo = ({
    powertrainName = '',
    siteName = '',
    locationName = '',
    className = '',
    showPlaceholders = false
}) => {
    const { t: translate } = useTranslation();

    return (
        <div className={`powertrain-basic-info ${className}`}>
            <h4 className='section-title'>{translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_Steps_BasicInfoTitle')}</h4>
            <div className='basic-info-grid'>
                <div className='info-item'>
                    <div className='info-label'>{translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_PowertrainNameLabel')}</div>
                    <div className='info-value'>
                        <span className='info-value-text'>
                            {powertrainName || (showPlaceholders && powertrainName !== '' && powertrainName !== null
                                ? translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_PowertrainNameDisplayPlaceholder')
                                : translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_NotSpecified'))}
                        </span>
                    </div>
                </div>
                <div className='info-item'>
                    <div className='info-label'>{translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_SiteLabel')}</div>
                    <div className='info-value'>
                        <span className='info-value-text'>
                            {siteName || (showPlaceholders && siteName !== '' && siteName !== null
                                ? translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_SiteNameDisplayPlaceholder')
                                : translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_NotSpecified'))}
                        </span>
                    </div>
                </div>
                <div className='info-item'>
                    <div className='info-label'>{translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_LocationLabel')}</div>
                    <div className='info-value'>
                        <span className='info-value-text'>
                            {locationName || (showPlaceholders && locationName !== '' && locationName !== null
                                ? translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_LocationNameDisplayPlaceholder')
                                : translate('ABB.Powertrain.Frontend.ptToolsPowertrainWizard_BasicInfo_NotSpecified'))}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

PowertrainBasicInfo.propTypes = {
    powertrainName: PropTypes.string,
    siteName: PropTypes.string,
    locationName: PropTypes.string,
    className: PropTypes.string,
    showPlaceholders: PropTypes.bool
};

export default PowertrainBasicInfo;
